module.exports = __webpack_public_path__ + "static/media/gris-g.de0e7ec6.mp3";